import { inject } from '@angular/core';
import { Router, CanActivateFn, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Root ('') redirect: sends the user to their preferred module.
 *
 * Reads `default_module` from the current user (falls back to 'finance').
 * Runs under the app-layout route which is already behind authGuard, so the
 * user is loaded by the time this evaluates.
 */
export const defaultModuleGuard: CanActivateFn = (): UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const module = authService.currentUser?.default_module || 'finance';
  return router.createUrlTree([`/${module}`]);
};
